/* eslint-disable import/no-mutable-exports */
let localizePortfolioTemplates = () => {};

export function loadPortfolioTemplates(locales) {
  localizePortfolioTemplates = (templates) => {
    return templates.map((template) => {
      const templateId = template.id;
      const localizedTitle = locales.portfolio.template.titles[templateId];

      return {
        ...template,
        title: localizedTitle || template.title,
        attributes: template.attributes
          ? {
              ...template.attributes,
              title: localizedTitle || template.attributes.title,
            }
          : undefined,
      };
    });
  };
}

export { localizePortfolioTemplates };
